import { field, date, relation,text } from '@nozbe/watermelondb/decorators';
import { NOTIFICATIONS_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class Notifications extends Model {
    static table = NOTIFICATIONS_SCHEMA;

    static associations = {
        user: { type: 'belongs_to', key: 'user_id' },
    }

    @field('supplier_order_number') supplier_order_number;
    @field('customer_order_number') customer_order_number;
    @text('supplier_image') supplier_image;
    @text('session_key') session_key;
    @text('supplier_id') supplier_id;
    @text('cta_color') cta_color;
    @text('btn_title') btn_title;
    @text('btn_color') btn_color;
    @text('supplier') supplier;
    @text('btn_icon') btn_icon;
    @text('web_slug') web_slug;
    @text('favicon') favicon;
    @text('message') message;
    @text('status') status;
    @text('title') title;
    @text('type') type;

    @date('sync_timestamp_unix') sync_timestamp_unix;
    @date('created_at') created_at;

    @relation('user', 'user_id') user;
};
